/**
 * `GET /me` for the whoami view. The cloud answers it; a node serves the
 * rundown API only (apps/state-service: "the tenancy routes are the cloud's")
 * and answers `not-found` — which is a fact to show, not an error.
 */
import { ApiError, type ApiClient } from '@norna/api-client/client.js';
import type { MeResponseWire } from '@norna/api-contract/tenancy.js';
import { queryOptions } from '@tanstack/react-query';

export type MeResult = { readonly available: true; readonly me: MeResponseWire } | { readonly available: false; readonly reason: string };

export function meQuery(api: ApiClient) {
  return queryOptions({
    queryKey: ['me'] as const,
    queryFn: async (): Promise<MeResult> => {
      try {
        return { available: true, me: await api.call('getMe', { params: null, query: null, body: null }) };
      } catch (err) {
        if (err instanceof ApiError && err.code === 'not-found') return { available: false, reason: 'this backend does not serve /me (a node serves the rundown API only)' };
        throw err;
      }
    },
  });
}
